import { cn } from "@/lib/utils";

export const ProgressSectionHeader = ({ eyebrow, title, description, className }) => (
  <div className={cn("min-w-0", className)}>
    {eyebrow ? (
      <p className="card-label">{eyebrow}</p>
    ) : null}
    {title ? (
      <h3 className="section-title mt-1">{title}</h3>
    ) : null}
    {description ? (
      <p className="section-description mt-2 max-w-2xl">{description}</p>
    ) : null}
  </div>
);
